export const ROLE_LABELS = {
  owner: { label: "Owner", color: "bg-amber-500/20 text-amber-400" },
  admin: { label: "Admin", color: "bg-purple-500/20 text-purple-400" },
  compliance_officer: { label: "Cumplimiento", color: "bg-blue-500/20 text-blue-400" },
  capturista: { label: "Capturista", color: "bg-slate-500/20 text-slate-400" },
  superadmin: { label: "Superadmin", color: "bg-rose-500/20 text-rose-300" },
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
